module.exports = __webpack_public_path__ + "media/coin_pickup_01.b1cf9a65.wav";